import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";
import LogoWhite from "../images/LogoWhite.svg";

const Footer = () => {
  return (
    <footer
      className="bg-[#272e02] text-white py-4"
      style={{ fontFamily: "Inter18Light" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
          {/* Logo Block */}
          <div className="flex flex-col items-center md:items-start">
            <img
              src={LogoWhite}
              alt="Logo"
              className="h-16 object-contain mb-3"
            />

            {/* Social Icons */}
            <div className="flex space-x-4 mt-2">
              <a
                href="https://www.instagram.com/solivera.oil/" // your Instagram link
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <FaInstagram size={22} />
              </a>
              <a
                href="https://www.facebook.com/share/17ZDy718YL/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <FaFacebook size={22} />
              </a>
              <a
                href="https://www.linkedin.com/" // your LinkedIn link
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <FaLinkedin size={22} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col text-center md:text-left">
            <h6 className="text-white font-medium text-base mb-2 uppercase tracking-wider">
              Quick Links
            </h6>
            <ul className="space-y-1">
              {[
                { label: "Home", to: "/" },
                { label: "Story", to: "/story" },
                { label: "Products", to: "/products" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className="text-gray-300 hover:text-white transition-all duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col md:flex-row md:justify-between">
            <div className="flex-1 space-y-1 text-gray-200 text-sm md:text-sm mb-3 md:mb-0 leading-relaxed">
              <p className="font-medium text-white text-base mb-1">Solivera</p>

              <p>
                <span className="font-medium text-[#c3d69b]">
                  Adresse Usine:
                </span>{" "}
                Huilerie CHELBI, X6PW+6W, Sidi Belal Kairouan – Tunisia
              </p>

              <p>
                <span className="font-medium text-[#c3d69b]">
                  Adresse Siége:
                </span>{" "}
                YASMINE TOWER BLOC A -A4.3 Centre Urbain Nord Tunisie
              </p>

              <p>
                <span className="font-medium text-[#c3d69b]">Phone:</span> +216
                21 226 653
              </p>
              <p className="whitespace-nowrap">
                <span className="font-medium text-[#c3d69b]">Email:</span>{" "}
                <a
                  href="mailto:contact@solivera-oil.com"
                  className="hover:text-white underline underline-offset-2"
                >
                  contact@solivera-oil.com
                </a>
              </p>
            </div>
            {/* Google Map */}
            <div className="flex-1 w-full h-32 rounded-xl overflow-hidden shadow-lg border border-[#1b4600] hover:border-[#2d7a00] transition-all duration-300 md:ml-5">
              <iframe
                className="w-full h-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.0000000000005!2d10.2473406!3d35.9855946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fdbd000b3bc961%3A0x599892d14df0e481!2sHuilerie%20CHELBI!5e0!3m2!1sen!2stn!4v1699999999999"
                loading="lazy"
                style={{ border: 0 }}
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                title="Huilerie CHELBI Location"
              />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-4 border-t border-[#1b4600] pt-2 flex flex-col-reverse md:flex-row items-center justify-between gap-2">
          <p className="text-gray-400 text-sm tracking-wide">
            © {new Date().getFullYear()} Solivera. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
